






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import SalutationSelect from '@/modules/conservatorship/components/SalutationSelect.vue';
import { Conservator, UpdateHourlyRate } from '@/modules/conservator/types';
import { UPDATE_HOURLY_RATE } from '@/modules/employee/store';
import { MapViewToUpdateHourlyRate } from '@/modules/conservator/models';

const Conservator = namespace('conservator');

@Component({
  components: {
    SalutationSelect
  }
})
export default class UpdateHourlyRateDialog extends Vue {
  @Prop() value!: Conservator | null;

  @Conservator.Action(UPDATE_HOURLY_RATE) updateHourlyRate!: (command: UpdateHourlyRate) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;

  conservator: UpdateHourlyRate = {
    conservator_id: '',
    hourly_rate: 0
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) return;

    setTimeout(() => {
      this.conservator = {
        conservator_id: '',
        hourly_rate: 0
      };

      this.error = null;
      this.$emit('input', null);
      // @ts-ignore
      this.$refs.form.reset();
    }, 200);
  }

  @Watch('value')
  watchValueSet(employee: Conservator) {
    if (!employee) return;

    this.init();

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  init() {
    if (!this.value) return;

    this.conservator = MapViewToUpdateHourlyRate(this.value);
  }

  async save(): Promise<ApiResponse> {
    this.error = null;

    return this.updateHourlyRate(this.conservator);
  }
}
